import React, { FC, useRef } from 'react'
import { Story, TStory } from '../index'
import FollowButtonContainer from '../../../modulesCommon/Follow/containers/FollowButton'

type TZoneFeedStoryProps = {
  story: TStory
  dataTestPrefix?: string
}

export const ZoneFeedStory: FC<TZoneFeedStoryProps> = (props) => {
  const storyRef = useRef<HTMLDivElement>(null)
  const { story } = props

  return (
    <Story.Container story={story} storyRef={storyRef}>
      <Story.Header
        actions={
          <FollowButtonContainer
            projectId={String(story.campaign.id)}
            projectName={`${story.artist.name} ${story.campaign.name}`}
            userId={story.campaign.owner_id}
          />
        }
      />
      <Story.Body>
        <Story.Article storyRef={storyRef} />
        <Story.Gallery />
        <Story.Comments />
      </Story.Body>

      <Story.Section>
        <Story.Meta />
        <Story.Tags />
      </Story.Section>

      {/*{shareWithROModal}*/}
    </Story.Container>
  )
}
